import { CommunitySection } from "../enums/CommunitySection";
import { CommunityDiscussion } from "../models/CommunityDiscuss";
import { CommunityDiscussionsItem } from "./CommunitySectionItem";

type Props = {
    sectionSelected: CommunitySection;
    list: CommunityDiscussion[];
    onEnter: (id: number) => void;
    onEdit: (id: number) => void;
    onArchive: (id: number) => void;
    onCreateDiscussion: () => void;
}

export const CommunityList = ({ sectionSelected, list, onEnter, onEdit, onArchive, onCreateDiscussion }: Props) => {
    return (
        <>
            { list.length > 0 ? (
                <>
                    <div className="community-list-items">
                        { list.map((l,i) => (
                            <CommunityDiscussionsItem
                                key={i}
                                id={l.id}
                                host={l.host}
                                notifications={l.notifications}
                                avatar={l.avatar}
                                author={l.author}
                                title={l.title}
                                tags={l.tags}
                                details={l.details}
                                comments={l.comments}
                                members={l.members}
                                memberComments={l.memberComments}
                                onEnter={onEnter}
                                onEdit={onEdit}
                                onArchive={onArchive}
                            />
                        ))}
                    </div>
                </>
            ):(
                <div className="community-empty-list">
                    <span>You don't have any {sectionSelected===CommunitySection.mastermindCircles ? 'Mastermind Circle': 'Open Discussions'}  yet, create one now</span>
                    <button onClick={onCreateDiscussion}>Create {sectionSelected===CommunitySection.mastermindCircles ? 'mastermind circle': 'open discussions'}</button>
                </div>
            )}
        </>
    )
}